// @ts-ignore
import { getDeviceIDFromLocalStorage } from '../analytics/handlers/amplitude/deviceIDStorageUtils';
import { getLogger } from '../base/logging/functions';
const logger = getLogger('features/deep-linking');
/**
 * Tries to load an image from a local server.
 * This approach is widely used to bypass CORS retrictions and avoid
 * deploying a https server on the client side which would also imply
 * storing SSL certificates on that client.
 *
 * @param {number} port - The port on which we try to reach the server.
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<void>}
 */
function tryPort(port, state) {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        const roomName = window.location.pathname;
        img.onload = resolve;
        img.onerror = reject;
        const url = `http://localhost:${port}${roomName}${generateParams(state)}`;
        img.src = url;
    });
}
/**
 * Generates search params to be passed to the deep linking VOD URL.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {string} - String with the params.
 */
function generateParams(state) {
    const { locationURL } = state['features/base/connection'];
    const { hash, search } = locationURL || {};
    // The device ID will always be available in local storage after the Amplitude initialization executes.
    const deviceId = getDeviceIDFromLocalStorage();
    return `${search ? `${search}&` : '?'}ts=${Date.now()}${deviceId ? `&__AMDID=${deviceId}` : ''}${hash ? `&${hash.substring(1)}` : ''}`;
}
/**
 * Opens Electron (desktop) container app.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<boolean>} - Resolves with true if the attempt to open the Electron container app was successful
 * and resolves with false otherwise.
 */
export async function _openDesktopApp(state) {
    const userAgent = navigator.userAgent.toLowerCase();
    const isRunningInElectron = userAgent.indexOf('8x8work') > -1 || userAgent.indexOf('electron') > -1;
    if (isRunningInElectron) {
        logger.info('Trying to deeplink prevented due to running in Electron');
        return false;
    }
    for (const port of [59201, 8430, 43618]) {
        try {
            await tryPort(port, state);
            logger.info('Trying to deeplink succeeded', port);
            return true;
        }
        catch (err) {
            logger.error('Trying to deeplink failed', err);
        }
    }
    return false;
}
